import Vuex from 'vuex'
import Vue from 'vue'
import { removeRefreshToken, removeToken } from './core/utils/token'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    user: null,
    permission: [],
    _mapboxToken:
      'pk.eyJ1Ijoia2luZ29mc2Fuam9zZSIsImEiOiJja2M1NHpzcTkwOTVmMnFwY2pmbWJoNXB5In0.bsMrsTi_pZxRe8yDkqYg4A'
  },
  mutations: {
    setUser(state, userInfo) {
      state.user = userInfo
    }
  },
  getters: {
    user: state => state.user,
    username: state => state.user.username,
    nickname: state => state.user.nickname,
    email: state => state.user.email,
    mapboxToken: state => state._mapboxToken
  },
  actions: {
    logOut() {
      this.commit('setUser', null)
      removeToken()
      removeRefreshToken()
    }
  }
})
